import { Badge } from '@/components/ui/badge'

const CustomAvatar = ({ avatar, width, height, isVip, text, onClick }) => {
  return (
    <div className="relative">
      <div onClick={onClick}>
        <img src={avatar} alt="" width={width} height={height} style={{ height, width }} className="rounded-full border-2 border-solid border-foreground/80" />
      </div>
      {text && isVip && (
        <Badge variant="destructive" className="absolute bottom-0 right-0 z-10 border-2 border-solid border-foreground/80 text-xs font-bold">
          {text}
        </Badge>
      )}
    </div>
  )
}

export default CustomAvatar
